import { IsContactEnum, useAppStore } from '@halo/chat-sdk-react';
import { useContactsStore } from '@/store/contacts';

export const useContactsQuery = (user_id: string, fromDb = false) => {
  const [isContact, setIsContact] = useState(true);
  const { client } = useAppStore();
  const { contacts } = useContactsStore();

  const isContactFromStore = useMemo(() => {
    return contacts.some((contact) => contact.user_id === user_id);
  }, [contacts, user_id]);

  const contactsQuery = useCallback(async () => {
    const res = await client?.Api.contacts.contactsQuery(user_id);
    setIsContact(res?.category == IsContactEnum.YES);
  }, [client?.Api.contacts, user_id]);

  useEffect(() => {
    if (user_id && fromDb) {
      contactsQuery();
    } else {
      setIsContact(isContactFromStore);
    }
  }, [user_id, contactsQuery, fromDb, isContactFromStore]);

  return {
    isContact,
  };
};
